export const BASE_URL = window.__env.BASE_URL
export const GOGUEST_CONSOLE_BASE_URL = window.__env.GOGUEST_CONSOLE_BASE_URL
export const GOGUEST_API_BASE_URL = window.__env.GOGUEST_API_BASE_URL
export const EXTENSION_API_BASE_URL = window.__env.EXTENSION_API_BASE_URL